import React from 'react'
import {
    Input
} from 'reactstrap'
import { AddCommaNumber } from '../../helpers/Utils';
import { NormalizeIntegerInput } from '../../helpers/NumberInput';

const ContentComponent = (props) => {
    const onChange = (event) => {
        props.onChange({
            target: {
                name: event.target.name,
                value: NormalizeIntegerInput(event.target.value),
            },
        });
    };

    return (
        <Input
            name={props.name || "undefined"}
            disabled={props.disabled || false}
            value={AddCommaNumber(props.value)}
            onChange={onChange}
            type="text"
            inputMode="numeric"
            placeholder={props.placeholder}
        />
    )
}

export default ContentComponent;
